
import ApiService from '../base/api_service';

export const getPiutang = async (accessToken, crediturId) => {
    try {
        const response = await ApiService.get(`/piutang?creditur_id=${crediturId}`, {
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json'
            }
        })

        return response

    } catch (error) {
        return error.response;
    }
}

export const showPiutang = async (accessToken, crediturId) => {
    try {
        const response = await ApiService.get(`/piutang/show/${crediturId}`, {
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json'
            }
        })

        return response

    } catch (error) {
        return error.response;
    }
}

export const postPiutang = async (accessToken, data) => {
    try {
        const response = await ApiService.post('/piutang/create', data, {
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json'
            }
        })

        return response

    } catch (error) {
        return error.response;
    }
}